import fetch from "@/utils/request";


const device_no: any = sessionStorage.getItem("device_no");
const sysyem: any = sessionStorage.getItem("sysyem");
const version: any = sessionStorage.getItem("version");
const device: any = sessionStorage.getItem("device");
const clientTypes: any = sessionStorage.getItem("clientTypes");
const network: any = sessionStorage.getItem("network");
const key: any = sessionStorage.getItem("key");

export default {
  quoteQueryMarketPackageApi(data: any) {
    return fetch({
      customLoading:true,
      url: "/quote/quote/query_market_package",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // /v1/prebatchorder
  v1PrebatchorderApi(data?: any, headers?: any) {
    headers.post["gf-deviceno"] = sessionStorage.getItem("device_no") || "";
    return fetch({
      url: "/gotrade/v1/prebatchorder",
      method: "post",
      headers,
      data
    });
  },
  quoteQryAccountMarginRentApi(data: any) {
    return fetch({
      url: "/trade/trade/qry_account_margin_rent",
      method: "get",
      data,
      headers: {
        "get": {
          "X-channel-id": 1
        }
      }
    });
  },


  quoteQueryChangeunitApi(data: any) {
    return fetch({
      url: "/quote/quote/querychangeunit",
      method: "get",
      data
    });
  },
  apiAuthLogout() {
    return fetch({
      url: "/php/api/auth/logout",
      method: "post",
      data: {
        source: "maH5"
      },
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 策略名称列表
  strategyNamelist() {
    return fetch({
      url: "/gotrade/v1/strategy/nameList",
      method: "get"
      // headers: {
      // 	'get': {
      // 		'platform': 'maH5',
      // 		'gf-deviceNo':sessionStorage.getItem("device_no") || '',
      // 		'gf-system':sessionStorage.getItem("sysyem") || '',
      // 		'gf-version':sessionStorage.getItem("version") || '',
      // 		'gf-device':sessionStorage.getItem("device") || '',
      // 		'gf-clientTypes':sessionStorage.getItem("clientTypes") || '',
      // 		'gf-network':sessionStorage.getItem("network") || '',
      // 		'gf-clientVersion':sessionStorage.getItem("key") || ''
      // 	}
      // }
    });
  },
  //查询合约信息
  quoteSymbolApi(data ?: object, headers ?: object): any {
    return fetch({
      url: "/quote/quote/symbol",
      method: "get",
      data,
      headers
    });
  },
  // 添加策略
  strategyAddApi(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/add",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 编辑修改策略
  strategyModifyApi(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/modify",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  // 查询策略详细信息
  strategyInfoApi(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/info",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  //登录 API，验证密码及获取相关用户信息（无token）
  h5PageLogin(data ?: object): any {
    return fetch({
      url: "/php/api/auth/login",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  //发送短信
  h5SenMsg(data ?: object): any {
    return fetch({
      url: "/php/api/tools/send_msg",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //使用短信登录校验
  h5msgCodeCheck(data ?: object): any {
    return fetch({
      url: "/php/api/auth/check/plateform/phone",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //短信验证
  h5PageCheck_phone(data ?: object): any {
    return fetch({
      url: "/php/api/auth/phone",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //获取期货禁止开仓的金额比例
  getAvailablerAtioAPI(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/getavailableratio",
      method: "get",
      data
    });
  },

  //设置期货禁止开仓的金额比例
  setAvailablerAtioAPI(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/setavailableratio",
      method: "post",
      data
    });
  },

  // 按组查
  getGroupList(data ?: object): any {
    return fetch({
      url: "/php/api/group/select_list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""

        }
      }
    });
  },
  // 按账户
  getAccountList(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/trade/select_list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  // 获取交易账号
  h5PageGetAccount(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/trade/select_list",
      method: "get",
      data
    });
  },
  //多账号列表
  accountList(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //组列表
  groupList(data ?: object): any {
    return fetch({
      url: "/php/api/group/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //删除账号
  accountDel(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/delete",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //连接账号
  accountConnext(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/connect",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //添加账号
  addAccount(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/add",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //操作日志
  recordList(data ?: object): any {
    return fetch({
      url: "/php/api/system/record/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //获取账户的交易账户列表
  accountTradeList(data ?: object): any {
    return fetch({
      url: "/php/api/group/account/trade/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //获取账户的交易账户列表
  groupTradeList(data ?: object): any {
    return fetch({
      url: "/php/api/group/trade/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  addgroupTrade(data ?: object): any {
    return fetch({

      url: "/php/api/group/account/trade/add",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //资金明细-资金
  // 文档：http://172.16.30.245:8083/project/168/interface/api/17313
  querygroupfund(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/querygroupfund",
      method: "get",
      headers,
      data
    });
  },
  // 批量下单
  queryBatchorder(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/batchorder",
      method: "post",
      headers: {
        "post": {
          "X-channel-id": sessionStorage.getItem("xid") || "",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || "",
          "platform": "maH5",
          ...headers
        }
      },
      data
    });
  },
  //订单执行-母单
  queryparentorderlist(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/queryparentorderlist",
      method: "get",
      data
    });
  },
  //订单执行-子单
  querygrouporders(data ?: object): any {
    return fetch({
      url: "/gotrade/v1/querygrouporders",
      method: "get",
      data
    });
  },
  //订单执行-所有账户撤单
  batchcancel(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/batchcancel",
      method: "post",
      headers: {
        "post": {
          "X-channel-id": sessionStorage.getItem("xid") || "",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || "",
          "platform": "maH5"
        }
      },
      data
    });
  },

  //资金明细 - 持仓列表
  // 文档： http://172.16.30.245:8083/project/168/interface/api/17310
  querybatchpos(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/querybatchpos",
      method: "get",
      headers,
      data
    });
  },
  //资金明细 - 批量查询委托
  querybatchorders(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/querybatchorders",
      method: "get",
      headers,
      data
    });
  },
  //资金明细 - 商品行情
  // 文档：http://172.16.30.245:8083/project/190/interface/api/10407
  future_ticksnapshot(data ?: object): any {
    return fetch({
      url: "/quote/quote/future_ticksnapshot",
      method: "get",
      data,
      headers: {
        "get": {
          "X-channel-id": sessionStorage.getItem("xid") || "",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || "",
          "platform": "maH5"
        }
      },
    });
  },
  //资金明细 - 实时汇率
  // 文档：http://172.16.30.245:8083/project/190/interface/api/9516
  getRate(data ?: object): any {
    return fetch({
      url: "/quote/currency/rate",
      method: "get",
      data
    });
  },
  //资金明细 - 合约信息
  // 文档：http://172.16.30.245:8083/project/190/interface/api/9524
  getContractInfo(data ?: object): any {
    return fetch({
      url: "/quote/quote/contract_info",
      method: "get",
      data
    });
  },
  //资金明细 - 查询资金
  getQryFund(data ?: object): any {
    return fetch({
      url: "/php/trade/qry_fund",
      method: "get",
      data
    });
  },
  //资金明细 - 批量查询成交
  querybatchfill(data ?: object, headers ?: object): any {
    return fetch({
      url: "/gotrade/v1/querybatchfill",
      method: "get",
      headers,
      data
    });
  },
  // 获取交易设置
  getTransactionSettingList(data?: object): any {
    return fetch({
      url: "/php/api/user/transactionSetting/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 配置 交易设置
  setTransactionSetting(data?: object): any {
    return fetch({
      url: "/php/api/user/transactionSetting/setting",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  //查询交易所信息
  queryExchangeInfo(data ?: object): any {
    return fetch({
      url: "/quote/quote/exchange_info",
      method: "get",
      data
    });
  },
  // 更新token时长
  addTokenTime(data?: object): any {
    return fetch({
      url: "/php/api/auth/add_token_time",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  //资金明细 - 查询最小变动单位
  querychangeunit(data ?: object): any {
    return fetch({
      url: "/quote/quote/querychangeunit",
      method: "get",
      data
    });
  },

  // 获取设备号
  getToolDevice(data ?: object): any {
    return fetch({
      url: "/php/api/tools/device",
      customLoading:true,
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5"
        }
      }
    });
  },

  // 获取H5版本号
  getSystemParam(data ?: object): any {
    return fetch({
      url: "/php/api/tools/system/param",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5"
        }
      }
    });
  },

  // 设置倍数
  setAccountMultipleSet(data?: object): any {
    return fetch({
      url: "/php/api/group/account/multiple/set",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no"),
          "gf-system": sessionStorage.getItem("sysyem"),
          "gf-version": sessionStorage.getItem("version"),
          "gf-device": sessionStorage.getItem("device"),
          "gf-clientTypes": sessionStorage.getItem("clientTypes"),
          "gf-network": sessionStorage.getItem("network"),
          "gf-clientVersion": sessionStorage.getItem("key")
        }
      }
    });
  },

  // 获取策略列表接口
  strategyNameList(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/nameList",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  // 获取下单方式
  getOrderingMethod(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/nameList",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },

  // 获取策略名字列表
  getStrategyListApi(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/nameList",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 获取计划列表
  getPlanListByStrategyIdApi(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/list",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 停止策略
  setStrategyStop(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/stop",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 运行策略
  setStrategyStart(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/start",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 删除策略
  delStrategy(data?: object): any {
    return fetch({
      url: "/gotrade/v1/strategy/delete",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 获取反向下单模式方向
  getAccountReverseOrderApi() {
    return fetch({
      url: "/php/api/group/account/reverse/order",
      method: "get",
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 设置反向下单模式
  setAccountReverseOrderApi(data) {
    return fetch({
      url: "/php/api/group/account/reverse/order/set",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 所有策略的执行计划列表
  getPlanStatisticsListApi(data: any) {
    return fetch({
      url: "/gotrade/v1/strategy/planStatisticsList",
      method: "get",
      data,
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 最新未读消息
  getStationMessagelastListApi(data: any) {
    return fetch({
      url: "/message/api/stationMessage/lastList",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 最新未读消息接口
  getUnreadMessage(data?: object): any {
    return fetch({
      url: "/message/api/stationMessage/unRead",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    });
  },
  // 获取消息列表
  getStationMessageListApi(data: any) {
    return fetch({
      url: "/message/api/stationMessage/list",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        },
      }
    });
  },
  // v2获取站内未读信息列表
  getStationMessageListApiV2(data: any) {
    return fetch({
      url: "/message/api/v2/stationMessage/list",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        },
      }
    });
  },
  // v2更新已读
  getStationMessageReadSetApiV2(data: any) {
    return fetch({
      url: "/message/api/v2/stationMessage/read/set",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        },
      }
    });
  },
  // 更新已读状态
  getStationMessageReadSetApi(data: any) {
    return fetch({
      url: "/message/api/stationMessage/read/set",
      method: "post",
      data,
      headers: {
        "post": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        },
      }
    });
  },

  getIpApi() {
    return fetch({
      url: "/php/api/tools/getIp",
      method: "get",
      data: {
        source: "maH5"
      },
      headers: {
        "get": {
          "platform": "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ""
        }
      }
    })
  },

  getQueryMarketPackageApi  () {
    return fetch({
      url: "/quote/quote/query_market_package",
      customLoading:true,
      method: "get",
      headers: {
        "get": {
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "platform": "APP"
        }
      }
    })
  },
  // 获取行业板块排行
  getQueryIndexAllApi  (data) {
    return fetch({
      url: "/quote/quote/index_all",
      method: "get",
      data,
      customLoading:true,
      headers: {
        "get": {
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "platform": "APP"
        }
      }
    })
  }
};
